import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import ProjectQueueTaskListRequest from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListRequest';
import ProjectQueueTaskCreateRequest from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskCreateRequest';
import ProjectQueueTaskUpdateRequest from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskUpdateRequest';
import QueueTaskUpdateNameRequest from '../../../projects/groups/i-service/model/queue-tasks/QueueTaskUpdateNameRequest';
import QueueTaskUpdateGroupIdRequest from '../../../projects/groups/i-service/model/queue-tasks/QueueTaskUpdateGroupIdRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import ProjectQueueTaskListResponse from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListResponse';
import ProjectQueueTaskListItem from '../../../projects/groups/i-service/model/queue-tasks/ProjectQueueTaskListItem';

export default class ProjectQueueTaskService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	GetListEvent = new Events<WsResponseModelT<ProjectQueueTaskListResponse>>();
	CreateEvent = new Events<WsResponseModelT<ProjectQueueTaskListItem>>();
	UpdateEvent = new Events<WsResponseModelT<ProjectQueueTaskListItem>>();
	UpdateNameEvent = new Events<WsResponseModelT<Boolean>>();
	UpdateGroupIdEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteEvent = new Events<WsResponseModelT<String>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('ProjectQueueTaskService', 'GetList', 'Main', (res: WsResponseModelT<ProjectQueueTaskListResponse>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('ProjectQueueTaskService', 'Create', 'Main', (res: WsResponseModelT<ProjectQueueTaskListItem>) => {
			self.CreateEvent.trigger(res);
		});
		webApiService.on('ProjectQueueTaskService', 'Update', 'Main', (res: WsResponseModelT<ProjectQueueTaskListItem>) => {
			self.UpdateEvent.trigger(res);
		});
		webApiService.on('ProjectQueueTaskService', 'UpdateName', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateNameEvent.trigger(res);
		});
		webApiService.on('ProjectQueueTaskService', 'UpdateGroupId', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UpdateGroupIdEvent.trigger(res);
		});
		webApiService.on('ProjectQueueTaskService', 'Delete', 'Main', (res: WsResponseModelT<String>) => {
			self.DeleteEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * получить список очередей задач
	 */
	async GetList(request: ProjectQueueTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'GetList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Добавить очередь задач в проект
	 */
	async Create(request: ProjectQueueTaskCreateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'Create',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновить очередь задач
	 */
	async Update(request: ProjectQueueTaskUpdateRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'Update',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление название очереди задач
	 */
	async UpdateName(request: QueueTaskUpdateNameRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'UpdateName',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Обновление название очереди задач
	 */
	async UpdateGroupId(request: QueueTaskUpdateGroupIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'UpdateGroupId',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить очередь задач из проекта
	 */
	async Delete(id: string) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectQueueTaskService',
			Method: 'Delete',
			Value: typeof(id) === 'object' ? JSON.stringify(id) : id,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * получить список очередей задач
	 */
	async getListAsync(request: ProjectQueueTaskListRequest): Promise<ProjectQueueTaskListResponse> {
		return new Promise<ProjectQueueTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'GetList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectQueueTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectQueueTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Добавить очередь задач в проект
	 */
	async createAsync(request: ProjectQueueTaskCreateRequest): Promise<ProjectQueueTaskListItem> {
		return new Promise<ProjectQueueTaskListItem>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'Create',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectQueueTaskListItem>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectQueueTaskListItem)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновить очередь задач
	 */
	async updateAsync(request: ProjectQueueTaskUpdateRequest): Promise<ProjectQueueTaskListItem> {
		return new Promise<ProjectQueueTaskListItem>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'Update',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProjectQueueTaskListItem>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProjectQueueTaskListItem)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление название очереди задач
	 */
	async updateNameAsync(request: QueueTaskUpdateNameRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'UpdateName',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Обновление название очереди задач
	 */
	async updateGroupIdAsync(request: QueueTaskUpdateGroupIdRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'UpdateGroupId',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить очередь задач из проекта
	 */
	async deleteAsync(id: string): Promise<String> {
		return new Promise<String>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectQueueTaskService',
				Method: 'Delete',
				Value: typeof(id) === 'object' ? JSON.stringify(id) : id,
				Callback: (response: WsResponseModelT<String>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as String)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}